import { commentsItems } from '@/mocks/homeMangaData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">读者评价</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            来自真实读者的使用反馈，看看大家对咻咻漫画的评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          {commentsItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    width="40"
                    height="40"
                    onError={(e) => {
                      const t = e.currentTarget;
                      t.style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900">{item.name}</span>
                    <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded text-[10px] font-medium">
                      {item.badge}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-background-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}